// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import { xCommonLoadingOverlay } from "@werner/App/Handlers/XNG/Common";
import React, { FC, useEffect } from "react";

interface OwnProps {
    children?: React.ReactNode;
    loading: boolean;
    id: string;
}

/**
 * Inner Component uses inside widgets and component
 * @param id
 * @param loading
 * @param children
 * @constructor
 */
const XngLoadingOverlay: FC<OwnProps> = ({ id, loading, children }) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (loading) {
            dispatch(xCommonLoadingOverlay({ key: "add", value: id }));
        } else {
            dispatch(xCommonLoadingOverlay({ key: "clear", value: id }));
        }
    }, [loading]);

    return <>{children}</>;
};

export default XngLoadingOverlay;
